import type { NavItem } from '../types/navItemType';

export const navItems: NavItem[] = [
  { id: 'lobby', href: '/', icon: 'lobby', label: 'Lobby', match: /^\/$/ },
  { id: 'purchases', icon: 'purchases', label: 'Purchases' },
  { id: 'menu', icon: 'menu', label: 'Menu' },
  { id: 'online-support', icon: 'support-navbar', label: 'Support', match: /^\/$/ },
];
